<template>
  <div>
    <div class="pl-5 pr-5">
      <h2>{{ $t("purchased-feature.edit") }}</h2>

      <b-card v-if="editedOrganization">
        <h4>{{ editedOrganization.name }}</h4>

        <b-form-checkbox switch size="sm" v-model="purchasedFeatures.hasDepartmentLimit" :value="true" :unchecked-value="false">
          {{ $t("purchased-feature.department-limit") }}
        </b-form-checkbox>

        <sweet-input
          v-if="purchasedFeatures.hasDepartmentLimit"
          v-model="purchasedFeatures.departmentLimit"
          :isValid="!$v.purchasedFeatures.departmentLimit.$error"
          :placeholder="$t('purchased-feature.department-limit')"
          @input="$v.purchasedFeatures.departmentLimit.$touch()"
          type="number"
          layout="vertical"
          inputClass="mb-1"
        />

        <h6 class="mt-4">
          {{ $t("purchased-feature.accessable-products") }}
        </h6>

        <multiselect
          v-model="purchasedFeatures.accessableProducts"
          :placeholder="$t('purchased-feature.accessable-products')"
          :options="['GDPR', 'KVKK', 'DDO', 'RISK', 'BGYS', 'TRAINING']"
          :searchable="false"
          :show-labels="false"
          :multiple="true"
        >
        </multiselect>
        <br />
        <h5 class="mt-4">Erişilebilir Özellikler</h5>
        <b-form-checkbox switch size="sm" v-model="purchasedFeatures.minimization" :value="true" :unchecked-value="false">
          Minimizasyon
        </b-form-checkbox>
        <b-form-checkbox switch size="sm" v-model="purchasedFeatures.riskPage" :value="true" :unchecked-value="false">
          Risk Sayfası
        </b-form-checkbox>

        <sweet-button @click="savePurchasedFeatures" type="submit" :disabled="$v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-4">
          {{ $t("common.save") }}
        </sweet-button>
      </b-card>
    </div>
  </div>
</template>

<script>
import { maxValue, minValue, required, requiredIf } from "vuelidate/lib/validators";

const state = "managementOrganization";
export default {
  components: {},
  data() {
    return {
      organization: undefined,
      purchasedFeatures: {
        hasDepartmentLimit: false,
        departmentLimit: 10000,
        accessableProducts: [],
      },
    };
  },

  computed: {
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    editedOrganization() {
      return this.$store.getters[`${state}/editedOrganization`];
    },
  },
  validations: {
    purchasedFeatures: {
      departmentLimit: {
        required: requiredIf(function(form) {
          return form.hasDepartmentLimit;
        }),
        maxValue: (value, vm) => {
          return vm.hasDepartmentLimit ? maxValue(1000)(value) : true;
        },
        minValue: (value, vm) => {
          return vm.hasDepartmentLimit ? minValue(1)(value) : true;
        },
      },
      accessableProducts: {
        required,
      },
    },
  },
  methods: {
    async savePurchasedFeatures() {
      try {
        await this.$store.dispatch(`managementPurchasedOrganizationFeature/update`, {
          payload: this.purchasedFeatures,
          sellable: "ORGANIZATION",
          organizationId: this.editedOrganization._id,
        });
        this.$toast.success(this.$t("common.successful"));
        this.purchasedFeatures = {};
        this.$root.$emit("bv::toggle::collapse", "sidebar-edit-organization-purchased-feature");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
